import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { currentAccountChildrenRoutes } from './currentAccountChildrenRoutes';

const NotFoundPage = lazy(() => import('../../../pages').then(module => ({ default: module.NotFound })));

const pendingInvoices = {
  path: 'facturas-pendientes',
  element: <Outlet />,
  errorElement: <NotFoundPage />,
  children: [
    ...currentAccountChildrenRoutes.map(({ path, element }) => ({
      path,
      element,
    })),
  ],
};

export default pendingInvoices;
